import { useState } from 'react'

import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateSendApprovalReminder } from '../../models/useMutateSendApprovalReminder'

export const useApprovalReminderIconButton = ({
  expenseId,
}: {
  expenseId: number
}) => {
  const intl = useProcurifyIntl()

  const [isModalOpen, setIsModalOpen] = useState(false)

  const { sendReminder } = useMutateSendApprovalReminder()

  const openReminderFormModal = () => {
    setIsModalOpen(true)
  }

  const closeReminderFormModal = () => {
    setIsModalOpen(false)
  }

  const submitApprovalReminder = async ({ message }: { message: string }) => {
    try {
      await sendReminder({ id: expenseId, message })

      closeReminderFormModal()

      toast.success({
        title: intl.formatMessage(messages.reminderSentToastTitle),
      })
    } catch (err) {
      toast.error({
        title: intl.formatMessage(messages.reminderErrorToastTitle),
      })
    }
  }

  return {
    states: {
      isModalOpen,
      modalTitle: `${intl.formatMessage(messages.modelTitle)} #${expenseId}`,
    },
    methods: {
      openReminderFormModal,
      closeReminderFormModal,
    },
    commands: {
      submitApprovalReminder,
    },
  }
}
